module.exports = __webpack_public_path__ + "static/media/menuGreen.226e9204.png";